import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import PlanSaveForm from "./PlanSaveForm";

const PlanSaveModal = props => {
    const { modalState, handleClose, translations, permissions, submitHandler, setModalState } = props;

    return (
        <Dialog
            open={modalState.open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['select_plan_version'] || 'Select plan version'}</DialogTitle>
            <DialogContent>
                <PlanSaveForm translations={translations} permissions={permissions} handleSubmit={submitHandler} modalState={modalState} setModalState={setModalState} />
            </DialogContent>
        </Dialog>
    );
}

export default PlanSaveModal;